module.exports = __webpack_public_path__ + "img/1573192099.e06dbf1c.jpg";